import React, { Component } from 'react'
import { withTranslation } from "react-i18next";

 class ZoomToolbar extends Component {
  render() {
    return (
      <li className="draw-toolbar-icon">
        <span
          className={`button normal-btn main-button ${this.props.activeButton === 'zoom-options' ? 'active' : ''}${
            this.props.hideButton ? "passive" : ""
          }`}
          title={this.props.t("Zoom Tools")}
          onClick={this.props.onClick}>
          <img
            src={require('../../assets/img/svg/toolbar-zoom-in.svg')}
            alt={this.props.t("Zoom Tools")}
             />
        </span>
      </li>
    )
  }
}
export default withTranslation()(ZoomToolbar);
